/*
 * @Author: FengXiao
 * @Date: 2020-07-01 22:08:41
 * @LastEditors: FengXiao
 * @LastEditTime: 2021-01-22 15:02:08
 */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fixedHeight: false,
    excludeRouters: '',
    international_show: false,
    miniGuideShow: false, // 购买引导弹层（隐私改版：需要用户身份的操作统一引导）
    guideType: 'mini', // 引导类型：'mini' 一席小程序 | 'app' 一席App下载
  },
  mutations: {
    showSearch(state, value) {
      state.fixedHeight = value;
    },
    setExcludeRouters(state, str) {
      state.excludeRouters = str;
    },
    setInternational_show(state, value) {
      state.international_show = value;
    },
    setMiniGuideShow(state, value) {
      state.miniGuideShow = value;
    },
    showGuide(state, type = 'mini') {
      state.miniGuideShow = true;
      state.guideType = type;
    },
  },
  modules: {},
});
